/* eslint-disable no-console */
import { MAIN } from '@/configs/main.config';
import { ENV } from '@/configs/env.config';
import { appInsights } from './telemetry/telemetry.service';

const isDevelopmentMode: boolean = ENV.APP_DEVELOPMENT_MODE;

const safeStringify = (obj: unknown): string => {
  try {
    return JSON.stringify(obj);
  } catch {
    return '[Object]';
  }
};

export interface Logger {
  log: (message: string, ...args: unknown[]) => void;
  warn: (message: string, ...args: unknown[]) => void;
  error: (message: string, error?: unknown) => void;
  critical: (message: string, error?: unknown) => void;
}

export const logger: Logger = {
  log: (message: string, ...args: unknown[]): void => {
    if (isDevelopmentMode) {
      console.log(`${MAIN.solgari}:`, message, ...args);
    }
    appInsights.trackTrace({
      message: `${message} ${args.map((arg) => (typeof arg === 'object' ? safeStringify(arg) : arg)).join(' ')}`,
      severityLevel: 1,
    });
  },

  warn: (message: string, ...args: unknown[]): void => {
    if (isDevelopmentMode) {
      console.warn(`${MAIN.solgari}:`, message, ...args);
    }
    appInsights.trackTrace({
      message: `${message} ${args.map((arg) => (typeof arg === 'object' ? safeStringify(arg) : arg)).join(' ')}`,
      severityLevel: 2,
    });
  },

  error: (message: string, error?: unknown): void => {
    console.error(`${MAIN.solgari}:`, message, error);
    if (error) {
      const errorObj: Error =
        error instanceof Error ? error : new Error(safeStringify(error));
      appInsights.trackException({ exception: errorObj });
    }
    appInsights.trackTrace({
      message: `${message}${error ? ` ${error instanceof Error ? error.message : safeStringify(error)}` : ''}`,
      severityLevel: 3,
    });
  },

  critical: (message: string, error?: unknown): void => {
    console.error(`${MAIN.solgari}:`, message, error);
    if (error) {
      const errorObj: Error =
        error instanceof Error ? error : new Error(safeStringify(error));
      appInsights.trackException({ exception: errorObj });
    }
    appInsights.trackTrace({
      message: `${message}${error ? ` ${error instanceof Error ? error.message : safeStringify(error)}` : ''}`,
      severityLevel: 4,
    });
  },
};
